import type { PropsWithChildren } from 'react';
import { lazy, Suspense } from 'react';

import { CardBody, CircleSkeleton } from '@/_components';

const ThemeChangeButton = lazy(() => import('./theme-change-button'));

export default function LayoutBody({ children }: PropsWithChildren<unknown>) {
  return (
    <>
      <div className="absolute inset-x-0 z-10 flex justify-end pt-4 pr-4">
        <Suspense fallback={<CircleSkeleton className="size-10" />}>
          <ThemeChangeButton />
        </Suspense>
      </div>
      <CardBody className="max-w-full px-8 pt-6 pb-12 sm:px-14 md:px-14">{children}</CardBody>
    </>
  );
}
